import { createI18n } from 'vue-i18n'
import it from './it.json'
import { getInitialWidgetLocale } from './widgetLocale.js'

// Detect initial locale from localStorage or browser
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getInitialWidgetLocale(),
  fallbackLocale: 'it',
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    it,
  },
})

export default i18n
